import PasswordResetSuccessContainer from "../containers/PasswordResetSuccessContainer";

const PasswordResetSuccessPage = () => {
  return <PasswordResetSuccessContainer />;
};

export default PasswordResetSuccessPage;
